import React from "react";

// Official Rainbow Worldwide logo (uploaded asset, transparent background)
export default function Logo({ onDark = false, className = "" }) {
  const img = (
    <img
      src="/rainbow-logo.webp"
      alt="Rainbow Worldwide"
      className={`w-auto select-none ${className || "h-9 sm:h-11"}`}
      draggable={false}
    />
  );
  if (onDark) {
    return <div className="inline-flex bg-white rounded-lg px-3 py-2 shadow-sm">{img}</div>;
  }
  return img;
}
